document.addEventListener("DOMContentLoaded", () => {
  // --- Helpers ---
  const sanitizeTableHTML = (wrapper) => {
    const allowed = ["TABLE", "TBODY", "THEAD", "TFOOT", "TR", "TH", "TD", "CAPTION"];

    wrapper.querySelectorAll("*").forEach(el => {
      if (!allowed.includes(el.tagName)) {
        // Replace disallowed element with its children
        while (el.firstChild) {
          el.parentNode.insertBefore(el.firstChild, el);
        }
        el.remove();
      } else {
        // Strip attributes
        [...el.attributes].forEach(attr => el.removeAttribute(attr.name));
      }
    });

    // Add class to <table>
    wrapper.querySelectorAll("table").forEach(table => {
      table.classList.add("sizing-table");

      // Convert first row <td> into <th>
      const firstRow = table.querySelector("tr");
      if (firstRow) {
        firstRow.querySelectorAll("td").forEach(td => {
          const th = document.createElement("th");
          th.innerHTML = td.innerHTML;
          td.replaceWith(th);
        });
      }
    });
  };

  // --- Main Logic ---
  const detailsAccordion = Array.from(document.querySelectorAll(".product__accordion"))
    .find(acc => acc.querySelector(".accordion__title")?.textContent.trim() === "Details");

  if (!detailsAccordion) return;

  const detailsContent = detailsAccordion.querySelector(".accordion__content");
  if (!detailsContent) return;

  const sizingHeading = Array.from(detailsContent.querySelectorAll("h6"))
    .find(h6 => h6.textContent.includes("Sizing"));

  if (!sizingHeading) return;

  const sizingWrapper = document.createElement("div");
  sizingWrapper.classList.add("sizing-details");

  let node = sizingHeading.nextSibling;
  while (node) {
    const next = node.nextSibling;
    sizingWrapper.appendChild(node);
    node = next;
  }

  sizingHeading.remove();

  sanitizeTableHTML(sizingWrapper);

  const sizingAccordion = Array.from(document.querySelectorAll(".product__accordion"))
    .find(acc => acc.querySelector(".accordion__title")?.textContent.trim() === "Sizing");

  if (sizingAccordion) {
    const sizingContent = sizingAccordion.querySelector(".accordion__content");
    if (sizingContent) {
      sizingContent.appendChild(sizingWrapper);
    }
  }


  //CUSTOM POPUP

  // Open modal
  document.querySelectorAll('.custom-popup-link button').forEach(button => {
    button.addEventListener('click', () => {
      const opener = button.closest('.custom-popup-link');
      const selector = opener.getAttribute('data-modal');
      const modal = document.querySelector(selector);
      if (!modal) return;

      modal.classList.add('open');
      document.body.classList.add('overflow-hidden');

      // Optional: focus trap can be added here if needed
    });
  });

  const openModal = (modal) => {
    if (!modal) return;

    document.body.classList.add('overflow-hidden');

    // trigger transition on next tick
    setTimeout(() => {
      modal.classList.add('open');
    }, 0);
  };

  const closeModal = (modal) => {
    if (!modal) return;

    // start fade out
    modal.classList.remove('open');

    // wait for transition to finish before removing overflow
    const onTransitionEnd = (e) => {
      if (e.target === modal) {
        document.body.classList.remove('overflow-hidden');
        modal.removeEventListener('transitionend', onTransitionEnd);
      }
    };
    modal.addEventListener('transitionend', onTransitionEnd);
  };

  // Open modal on opener click
  document.querySelectorAll('.custom-popup-link').forEach(opener => {
    opener.addEventListener('click', (e) => {
      e.preventDefault();
      const modalSelector = opener.getAttribute('data-modal');
      const modal = document.querySelector(modalSelector);
      openModal(modal);
    });
  });

  // Close modal on button click
  document.querySelectorAll('.product-popup-modal__toggle').forEach(closeBtn => {
    closeBtn.addEventListener('click', () => {
      const modal = closeBtn.closest('.product-popup-modal');
      closeModal(modal);
    });
  });

  // Close modal on backdrop click
  document.querySelectorAll('.product-popup-modal').forEach(modal => {
    modal.addEventListener('click', e => {
      if (e.target === modal) closeModal(modal);
    });
  });
  // Close modal on backdrop or overlay click
  document.querySelectorAll('.product-popup-modal').forEach(modal => {
    modal.addEventListener('click', e => {
      if (e.target === modal || e.target.classList.contains('product-popup-modal__overlay')) {
          closeModal(modal);
      }
    });
  });

  // Close modal on ESC key
  document.addEventListener('keyup', e => {
    if (e.key === "Escape") {
      document.querySelectorAll('.product-popup-modal.open').forEach(modal => {
        closeModal(modal);
      });
    }
  });
});
function setupAutoGrow(textarea) {
  // Set initial min-height
  const style = getComputedStyle(textarea);
  const closestInput = textarea.closest('form')?.querySelector('input');
  const minHeight = closestInput ? closestInput.offsetHeight : parseFloat(style.minHeight) || parseFloat(style.lineHeight);
  textarea.style.height = minHeight + 'px';
  textarea.style.overflowY = 'hidden'; // hide scrollbar

  function autoGrow() {
    textarea.style.height = minHeight + 'px'; // reset to min first
    textarea.style.height = textarea.scrollHeight + 'px'; // grow to fit content
  }

  // Run once immediately
  autoGrow();

  // Listen for user input
  textarea.addEventListener('input', autoGrow);
}

function initAutoGrow() {
  document.querySelectorAll('textarea').forEach(setupAutoGrow);
}

document.addEventListener('DOMContentLoaded', () => {
  initAutoGrow();

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.matches('textarea')) setupAutoGrow(node);
          node.querySelectorAll('textarea').forEach(setupAutoGrow);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Fallback for late-loaded textareas
  setTimeout(initAutoGrow, 2000);
});

